export default "__VITE_ASSET__BLKiD8ct__"